var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.7 24",
    style: {
      enableBackground: "new 0 0 38.7 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,17.3l-0.7-0.7l4.1-4.1H19.7v-1h12.1l-4.1-4.1l0.7-0.7l5.3,5.3L28.4,17.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 11.5,
    className: "st0",
    width: 13.2,
    height: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightThin);
export default __webpack_public_path__ + "static/media/arrow_right_thin.7fd2c3e6d2fbaa61e976e54fd7a5f3cd.svg";
export { ForwardRef as ReactComponent };